const NON_EDITABLE_TAG = 'SPAN';
const NON_EDITABLE_CLASS = 'cbNonEditable';

export const isTokenElement = (element: HTMLElement) => {
  return element.tagName.toUpperCase() === NON_EDITABLE_TAG && element.classList.contains(NON_EDITABLE_CLASS);
};
